import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTAddColumn from './TTAddColumn';
import { createColumn } from 'redux/translationTable/TranslationTableActions';

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ createColumn }, dispatch)
});

export default connect(null, mapDispatchToProps)(TTAddColumn);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttColumnManager/c/ttAddColumn/TTAddColumnsConnector.js